import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { ProductoService } from "src/app/services/producto.service";
import { RubroService } from "src/app/services/rubro.service";
import { VendedorService } from "src/app/services/vendedor.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { UtilsService } from "src/app/shared/services/utils.service";

@Component({
  selector: "app-productos-anualizado",
  templateUrl: "./productos-anualizado.component.html",
  styleUrls: ["./productos-anualizado.component.scss"],
  providers: [SecurityService]
})
export class ProductosAnualizadoComponent implements OnInit {
  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  listaMovimientosAgrupados: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null
  optionsYear: any[] = []

  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private productoService: ProductoService,
    private utilsService: UtilsService
  ) {
    this.log = this.clog.log('REP. PRODUCTOS ANUALIZADO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    this.loadMesesAndAnhos();

    this.loadRubros()

    this.createForm()
    this.formChangesSubscriptions()
  }

  loadMesesAndAnhos() {
    this.optionsYear = this.datesService.GetRangeYears()
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(rubro => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }))
    })
  }

  private createForm() {
    this.formHeader = this.fb.group({
      anno: [(new Date()).getFullYear()],
      listaRubro: [[]],
      listaFamilia: [[]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("listaRubro").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })
  }

  onRubroSelect(ev) {
    this.optionsFamilia = []

    const listaRubros = this.formHeader.get('listaRubro').value
    if (!listaRubros) return

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.paginationContext.CurrentPage = pageNumber

    const { anno, listaRubro, listaFamilia } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        listaRubro,
        listaFamilia,
        anno
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 // this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.listaMovimientos = null
    this.listaMovimientosAll = null
    
    this.listaMovimientosAgrupados = null

    this.productoService.obtenerReporteVentaProductoAnualizados(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.loading = false
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = this.utilsService.groupProductsBySKU(registros)
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.showPage(this.paginationContext.CurrentPage)
      this.calculateTotales()
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
    this.listaMovimientos =  _.slice(this.listaMovimientos)
  }

  calculateTotales() {
    this.resumen_totales = {
      enero: _.sumBy(this.listaMovimientosAll, 'enero'),
      febrero: _.sumBy(this.listaMovimientosAll, 'febrero'),
      marzo: _.sumBy(this.listaMovimientosAll, 'marzo'),
      abrir: _.sumBy(this.listaMovimientosAll, 'abrir'),
      mayo: _.sumBy(this.listaMovimientosAll, 'mayo'),
      junio: _.sumBy(this.listaMovimientosAll, 'junio'),
      julio: _.sumBy(this.listaMovimientosAll, 'julio'),
      agosto: _.sumBy(this.listaMovimientosAll, 'agosto'),
      septiembre: _.sumBy(this.listaMovimientosAll, 'septiembre'),
      octubre: _.sumBy(this.listaMovimientosAll, 'octubre'),
      noviembre: _.sumBy(this.listaMovimientosAll, 'noviembre'),
      diciembre: _.sumBy(this.listaMovimientosAll, 'diciembre'),
      acumulado: _.sumBy(this.listaMovimientosAll, 'acumulado'),
    }
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.productoService.obtenerReporteVentaProductoAnualizadosExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}
